export default __webpack_public_path__ + "static/media/method.e6250fa2.svg";